import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import './AppDatenschutz.css';
import { Header } from '../../components/header/Header';
import { MobileFooter } from '../../components/mobileFooter/MobileFooter';

export const AppDatenschutz = () => {
	const ref = useRef(null);
	const isInView = useInView(ref, { once: true, margin: '-100px' });

	return (
		<div>
			<Header style={{ backgroundColor: '#ffffff' }} />
			<div className='app-datenschutz-page'>
				<motion.div
					ref={ref}
					initial={{ opacity: 0, y: 20 }}
					animate={isInView ? { opacity: 1, y: 0 } : {}}
					transition={{ duration: 0.5, ease: 'easeOut' }}
					className='datenschutz-container'
				>
						<h1>Datenschutzerklaerung</h1>
						<p className='stand'>Erledix - Familienorganisation leicht gemacht | Stand: Mai 2026</p>

					<div className='datenschutz-content'>
						<p className='intro'>
								Der Schutz deiner personenbezogenen Daten liegt uns am Herzen. Diese Datenschutzerklaerung informiert dich darueber, welche Daten wir im Rahmen der Nutzung der App Erledix verarbeiten, zu welchem Zweck dies geschieht und welche Rechte dir zustehen.
						</p>

						<section>
							<h2>1. Verantwortlicher</h2>
								<p>Verantwortlich fuer die Verarbeitung personenbezogener Daten im Sinne der DSGVO ist:</p>
								<p>
									<strong>Unternehmen:</strong> Health365 IT GmbH
									<br />
									<strong>Adresse:</strong> Unter den Linden 10, 10117 Berlin
									<br />
									<strong>E-Mail:</strong> dsb@h365.de
									<br />
									<strong>Website:</strong> www.h365.de
								</p>
						</section>

						<section>
								<h2>2. Allgemeines</h2>
								<p>
									Wir verarbeiten personenbezogene Daten ausschliesslich im Einklang mit der Datenschutz-Grundverordnung (DSGVO) sowie den geltenden nationalen Datenschutzvorschriften.
								</p>
							</section>

							<section>
								<h2>3. Zweck der App</h2>
								<p>
									Erledix ist eine Familien-Organisations-App, die Eltern und Kinder dabei unterstuetzt, den gemeinsamen Alltag zu strukturieren: von der Aufgabenverteilung ueber Belohnungssysteme bis hin zur einfachen Kommunikation innerhalb der Familie.
								</p>
								<p>Personenbezogene Daten werden nur verarbeitet, soweit dies fuer die Bereitstellung der App-Funktionen erforderlich ist.</p>
							</section>

							<section>
								<h2>4. Rechtsgrundlagen der Datenverarbeitung</h2>
								<p>Wir stuetzen die Verarbeitung auf folgende Rechtsgrundlagen gemaess Art. 6 DSGVO:</p>
							<ul>
									<li>Art. 6 Abs. 1 lit. b DSGVO - Erfuellung des Nutzungsvertrags (z. B. Kontoerstellung, Aufgabenverwaltung, Belohnungen)</li>
									<li>Art. 6 Abs. 1 lit. a DSGVO - Einwilligung fuer optionale Funktionen innerhalb der App</li>
									<li>Art. 6 Abs. 1 lit. f DSGVO - Berechtigtes Interesse an einer stabilen, sicheren und fehlerfreien App</li>
							</ul>
						</section>

						<section>
								<h2>5. Verarbeitete Daten</h2>
								<h3>5.1 Elternkonto (Registrierung)</h3>
							<ul>
									<li>E-Mail-Adresse - zur Registrierung, Login-Verwaltung und Passwort-Zuruecksetzung</li>
									<li>Profilname und optionales Profilbild - zur Identifikation innerhalb der Familiengruppe</li>
									<li>Zugangsdaten - verschluesselt gespeichert (Passwoerter werden gehasht und gesalzen, niemals im Klartext)</li>
							</ul>

								<h3>5.2 Nutzung der App</h3>
							<ul>
									<li>Aufgaben, Belohnungen, Muenzen und Erledigungsstatus</li>
									<li>Kommentare/Notizen zu Aufgaben und Belohnungen</li>
									<li>Einladungscodes zur Verknuepfung von Eltern- und Kinderkonten</li>
									<li>PIN-Codes - ausschliesslich lokal auf dem Geraet im sicheren Keychain/Keystore gespeichert; niemals serverseitig</li>
									<li>Lokale Cache-Daten in AsyncStorage zur Offline-Unterstuetzung</li>
							</ul>

								<h3>5.3 Technische Daten</h3>
								<p>Zur Sicherstellung der App-Stabilitaet und Fehleranalyse verarbeiten wir:</p>
							<ul>
									<li>Geraeteinformationen (Betriebssystem, App-Version)</li>
									<li>Technische Diagnose- und Nutzungsdaten (Absturzberichte, Ladezeiten, Fehlermeldungen, anonymisierte Nutzungsereignisse)</li>
							</ul>
								<p>Diese Daten dienen ausschliesslich der technischen Optimierung und werden nicht fuer Werbung oder personalisierte Profile verwendet.</p>

								<h3>5.4 Kommunikation</h3>
								<p>Sofern du uns per E-Mail kontaktierst, verarbeiten wir die dabei uebermittelten Daten ausschliesslich zur Bearbeitung deiner Anfrage.</p>
						</section>

						<section>
								<h2>6. Daten, die wir bewusst nicht erheben</h2>
							<ul>
									<li>Standortdaten</li>
									<li>Kontakte oder Adressbuecher</li>
									<li>Fotos, Kamera- oder Galerie-Daten</li>
									<li>Social-Media-Informationen</li>
							</ul>
						</section>

						<section>
								<h2>7. Nutzung durch Kinder und Familien</h2>
								<p>Erledix richtet sich an Familien. Die App verfuegt ueber dedizierte Kinder- und Elternprofile.</p>
							<ul>
									<li>Eltern richten Kinderprofile ein und verwalten diese</li>
									<li>Kinder koennen die App auch ohne eigene E-Mail-Adresse ueber ein Gastprofil nutzen</li>
									<li>Eltern koennen Kinderprofile jederzeit loeschen</li>
									<li>Es werden keine sensiblen personenbezogenen Daten von Kindern verarbeitet</li>
							</ul>
						</section>

						<section>
								<h2>8. Eingesetzte Drittdienstleister und Datenweitergabe</h2>
								<p>Wir geben personenbezogene Daten nur im erforderlichen Umfang an folgende Dienstleister weiter. Alle Dienstleister sind vertraglich zur Einhaltung der DSGVO verpflichtet (Auftragsverarbeitungsvertrag gemaess Art. 28 DSGVO).</p>

								<h3>Supabase (Supabase Inc. / EU-Serverstandort Frankfurt)</h3>
								<p>Zweck: Backend, Datenbank, Authentifizierung</p>
								<p>Uebermittelte Daten: Nutzerprofile, Aufgaben, Belohnungen, Authentifizierungsdaten</p>
								<p>Serverstandort: EU (Frankfurt, AWS eu-central-1) - vollstaendig DSGVO-konform</p>
								<p>Datenschutzerklaerung: https://supabase.com/privacy</p>

								<h3>Google LLC / Gmail API (Mountain View, CA, USA)</h3>
								<p>Zweck: Versand von Passwort-Wiederherstellungs-E-Mails</p>
								<p>Uebermittelte Daten: Ausschliesslich die E-Mail-Adresse des Nutzers</p>
								<p>Serverstandort / Grundlage: USA - Datenuebermittlung auf Basis von Standardvertragsklauseln (SCC) gemaess Art. 46 Abs. 2 lit. c DSGVO</p>
								<p>Datenschutzerklaerung: https://policies.google.com/privacy</p>

								<h3>PostHog Inc. (San Francisco, CA, USA)</h3>
								<p>Zweck: Produktanalyse und App-Nutzungsstatistiken (keine personalisierte Werbung)</p>
								<p>Uebermittelte Daten: Anonymisierte Nutzungsereignisse, Geraeteinformationen, App-Version</p>
								<p>Serverstandort / Grundlage: EU-Region (EU Cloud) verfuegbar; ggf. USA auf Basis von SCC</p>
								<p>Datenschutzerklaerung: https://posthog.com/privacy</p>

								<h3>Expo Inc. (Mountain View, CA, USA)</h3>
								<p>Zweck: App-Framework und Infrastruktur fuer Push-Benachrichtigungen</p>
								<p>Uebermittelte Daten: Geraete-Push-Token</p>
								<p>Serverstandort / Grundlage: USA - Datenuebermittlung auf Basis von SCC</p>
								<p>Datenschutzerklaerung: https://expo.dev/privacy</p>

								<h3>Firebase Cloud Messaging / FCM (Google LLC, USA)</h3>
								<p>Zweck: Zustellung von Push-Benachrichtigungen auf Android-Geraeten</p>
								<p>Uebermittelte Daten: Geraete-Push-Token</p>
								<p>Serverstandort / Grundlage: USA - Datenuebermittlung auf Basis von SCC</p>
								<p>Datenschutzerklaerung: https://firebase.google.com/support/privacy</p>

								<h3>Apple Push Notification Service / APNs (Apple Inc., Cupertino, CA, USA)</h3>
								<p>Zweck: Zustellung von Push-Benachrichtigungen auf iOS-Geraeten</p>
								<p>Uebermittelte Daten: Geraete-Push-Token</p>
								<p>Serverstandort / Grundlage: USA - Datenuebermittlung auf Basis von SCC</p>
								<p>Datenschutzerklaerung: https://www.apple.com/legal/privacy/</p>

								<h3>Strato AG (Pascalstrasse 10, 10587 Berlin, Deutschland)</h3>
								<p>Zweck: Webhosting fuer erledix.de und h365.de</p>
								<p>Uebermittelte Daten: Server-Logfiles (IP-Adresse, Zeitstempel) - automatische Anonymisierung nach 7 Tagen</p>
								<p>Serverstandort: Deutschland</p>
								<p>Datenschutzerklaerung: https://www.strato.de/datenschutz/</p>

								<h3>Apple Inc. / App Store (One Apple Park Way, Cupertino, CA 95014, USA)</h3>
								<p>Zweck: Vertrieb und Auslieferung der iOS-App ueber den Apple App Store</p>
								<p>Uebermittelte Daten: Apple verarbeitet Geraete-Identifikatoren, Download-Metadaten und ggf. Zahlungsdaten im Rahmen des App-Downloads eigenverantwortlich</p>
								<p>Serverstandort / Grundlage: USA - Datenuebermittlung auf Basis von SCC; Apple ist selbst Verantwortlicher fuer die im App Store erhobenen Daten</p>
								<p>Datenschutzerklaerung: https://www.apple.com/legal/privacy/</p>

								<h3>Google LLC / Google Play Store (Mountain View, CA, USA)</h3>
								<p>Zweck: Vertrieb und Auslieferung der Android-App ueber den Google Play Store</p>
								<p>Uebermittelte Daten: Google verarbeitet Geraete-Identifikatoren, Download-Metadaten und ggf. Zahlungsdaten im Rahmen des App-Downloads eigenverantwortlich</p>
								<p>Serverstandort / Grundlage: USA - Datenuebermittlung auf Basis von SCC; Google ist selbst Verantwortlicher fuer die im Play Store erhobenen Daten</p>
								<p>Datenschutzerklaerung: https://policies.google.com/privacy</p>

								<h3>Expo / EAS - Expo Application Services (Expo Inc., Mountain View, CA, USA)</h3>
								<p>Zweck: App-Build-Infrastruktur, Over-the-Air-Updates (OTA) und Deployment via Expo Application Services</p>
								<p>Uebermittelte Daten: App-Bundle-Daten, Build-Konfigurationen; keine Endnutzerdaten werden an EAS uebermittelt</p>
								<p>Serverstandort / Grundlage: USA - Datenuebermittlung auf Basis von SCC</p>
								<p>Datenschutzerklaerung: https://expo.dev/privacy</p>

								<p>Eine Weitergabe an weitere Dritte erfolgt nicht, ausser wir sind gesetzlich dazu verpflichtet. Die App verwendet keine Werbe- oder Marketing-Trackingdienste und keine personalisierte Werbung.</p>
							</section>

							<section>
								<h2>9. Datenspeicherung und Sicherheit</h2>
								<h3>9.1 Technische Sicherheitsmassnahmen</h3>
								<ul>
									<li>TLS 1.2+ verschluesselte Verbindungen fuer alle Datenuebertragungen</li>
									<li>Verschluesselte Datenspeicherung auf dem Server</li>
									<li>Passwoerter werden gehasht und gesalzen gespeichert (niemals im Klartext)</li>
									<li>PIN-Codes ausschliesslich lokal im sicheren Keychain/Keystore</li>
									<li>Regelmaessige Sicherheits- und Systemupdates</li>
									<li>Strenge Zugriffs- und Rollenbeschraenkungen</li>
								</ul>
								<h3>9.2 Serverstandort</h3>
								<p>Alle personenbezogenen Kerndaten werden auf Supabase-Servern in der EU (Frankfurt) gespeichert und verarbeitet. Supabase ist vollstaendig DSGVO-konform. Systemseitige automatische Backups werden nach 7 Tagen geloescht.</p>
							</section>

							<section>
								<h2>10. Speicherdauer und Loeschung</h2>
								<p>Personenbezogene Daten werden nur so lange gespeichert, wie dies fuer die jeweiligen Zwecke erforderlich ist. Bei Loeschung des Kontos werden folgende Daten innerhalb von 30 Tagen unwiderruflich geloescht:</p>
								<ul>
									<li>Nutzerprofile (Eltern &amp; Kinder)</li>
									<li>Gruppen, Rollen und Mitgliedschaften</li>
									<li>Aufgaben, Erledigungen und Belohnungen</li>
									<li>Muenzkonten (Coins)</li>
									<li>Kommentare</li>
									<li>Authentifizierungsdaten (E-Mail, Passwort)</li>
								</ul>
								<p>Gesetzliche Aufbewahrungspflichten bleiben davon unberuehrt.</p>
							</section>

							<section>
								<h2>11. Keine Werbung ohne Einwilligung</h2>
								<p>Wir versenden keine werblichen E-Mails und machen keine Angebote zu kostenpflichtigen Leistungen ohne eine vorherige ausdrueckliche Einwilligung. Die App enthaelt keine personalisierte Werbung.</p>
							</section>

							<section>
								<h2>12. Deine Rechte</h2>
								<p>Als betroffene Person hast du jederzeit folgende Rechte:</p>
							<ul>
									<li>Auskunft ueber gespeicherte Daten (Art. 15 DSGVO)</li>
									<li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
									<li>Loeschung / Recht auf Vergessenwerden (Art. 17 DSGVO)</li>
									<li>Einschraenkung der Verarbeitung (Art. 18 DSGVO)</li>
									<li>Datenuebertragbarkeit (Art. 20 DSGVO)</li>
									<li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
							</ul>
								<p>Anfragen zur Ausuebung deiner Rechte richte bitte an: dsb@h365.de</p>
						</section>

						<section>
								<h2>13. Beschwerderecht</h2>
								<p>Du hast das Recht, dich bei einer Datenschutzaufsichtsbehoerde zu beschweren. Die zustaendige Aufsichtsbehoerde in Berlin ist:</p>
								<p>
									Berliner Beauftragte fuer Datenschutz und Informationsfreiheit
									<br />
									Friedrichstr. 219, 10969 Berlin | www.datenschutz-berlin.de
								</p>
						</section>

							<section>
								<h2>14. Hinweis zur Beta-Phase</h2>
								<p>Die App kann sich in einer aktiven Entwicklungsphase befinden. Trotz angemessener technischer und organisatorischer Sicherheitsmassnahmen koennen technische Fehler, temporaere Nichtverfuegbarkeit oder - in seltenen Ausnahmefaellen - Datenverluste nicht vollstaendig ausgeschlossen werden.</p>
							</section>

							<section className='contact-section'>
								<h2>15. Aenderungen dieser Datenschutzerklaerung</h2>
								<p>Wir behalten uns vor, diese Datenschutzerklaerung anzupassen, sofern rechtliche oder technische Aenderungen dies erfordern. Bei wesentlichen Aenderungen werden wir dich gesondert informieren.</p>
						</section>
					</div>
				</motion.div>
			</div>
			<MobileFooter />
		</div>
	);
};

